export default class FlickityPagination {
    constructor(element) {
        this.$element = $(element);
        this.$pagination = $(this.$element.data('flickityPagination'));
        this.flkty = Flickity.data(this.$element[0]);
    }

    updatePagination() {
        let cellNumber = this.flkty.selectedIndex + 1;
        this.$pagination.text(`${cellNumber}/${this.flkty.slides.length}`);
    }

    init() {
        this.$element
            .off('change.flickity', '', $.proxy(this, 'updatePagination'))
            .on('change.flickity', '', $.proxy(this, 'updatePagination'));

        this.updatePagination();
    }
}
